import { createFileRoute } from "@tanstack/react-router";
import { PixelTab } from "@/components/admin/PixelTab";

export const Route = createFileRoute("/admin/pixel")({
  head: () => ({
    meta: [
      { title: "Pixel & CAPI · Admin · INFLOW Marketing" },
      {
        name: "description",
        content: "Active Meta pixel, Conversions API status, and test event firing.",
      },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: () => (
    <div className="space-y-6">
      <div>
        <h1 className="font-serif text-3xl tracking-tight">Pixel &amp; Conversions API</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Which Meta pixel is live, what events are wired up, and a way to test them end to end.
        </p>
      </div>
      <PixelTab />
    </div>
  ),
});
